import { Pipe, PipeTransform } from '@angular/core';
import { Intake } from '@univacity/shared/types';

@Pipe({
  name: 'intakes',
  standalone: false,
})
export class IntakesPipe implements PipeTransform {
  transform(
    value: Intake[] | string[],
    direction: 'current' | 'next' = 'current',
    property:
      | 'startDate'
      | 'admissionStartDate'
      | 'admissionEndDate' = 'admissionEndDate'
  ): Intake | undefined {
    if (!value || (value && value.length > 0 && typeof value[0] === 'string'))
      return;
    const intakes = [...value];
    if (intakes.length === 0) return undefined;
    const now = new Date();
    const sortedIntakes: Intake[] = (intakes as Intake[]).sort(
      (a: Intake, b: Intake) =>
        new Date(a[property]) > new Date(b[property]) ? 1 : -1
    ) as Intake[];
    const filteredIntakes =
      direction === 'next'
        ? sortedIntakes.filter((i) => new Date(i[property]) > now)
        : sortedIntakes.filter(
            (i) =>
              new Date(i.admissionStartDate) <= now &&
              new Date(i.admissionEndDate) >= now
          );
    const fl = filteredIntakes.length;
    const next = fl > 0 ? filteredIntakes[0] : undefined;
    return next;
  }
}
